module.exports = __webpack_public_path__ + "img/used-car-store-choose.f02b1d1d.jpg";